"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.seconds_in_a_day = void 0;
exports.seconds_in_a_day = 60 * 60 * 24;
